import { useCookies } from '@catalogo/core-connect/cookies';
import { loadScripts } from '@catalogo/core-load-scripts';

type AskPermission = () => null | void;
type UseWebpush = () => [AskPermission];

interface WebPushManagerAPI {
  register: () => void;
  setUserId: (id: string) => void;
}
declare global {
  interface Window {
    webPushManagerAPI?: WebPushManagerAPI;
  }
}

export const credentials = {
  id: 'rsyswpsdk',
  wpconfig:
    '{"appserviceKey":"BGQKZ7lABUM-0vOF2ENDL7SnKkV6uSvaIrhqsigdnyhbskVBWQ-xDH8vPeCuYl98GX2WFG6dogc0ZcOR0A92e94=","apiKey":"ABEuf2rDNTJyKZZ9YBDky6-rs","accountToken":"ABEjx7nVhaPPxF1qMtBaKwG6Y","appver":"0.0.0","apiHost":"https://api.pushio.com","lazy":true}',
};

export const useWebpush: UseWebpush = () => {
  const [cookies] = useCookies();

  const askPermission: AskPermission = () => {
    if (Notification.permission === 'granted') {
      return null;
    }

    Notification.requestPermission().then(result => {
      if (result === 'granted') {
        loadScripts('https://api.pushio.com/webpush/sdk/wpIndex_min.js').then(() => {
          window.webPushManagerAPI?.register();

          if (cookies['customer.id']) {
            window.webPushManagerAPI?.setUserId(cookies['customer.id']);
          }
        });
      }
    });
  };

  return [askPermission];
};
